import { VALAQUENTA_API_URL } from "../../..";
import { loggingAxios } from "../../../../App";

export function sendLogsToVendor({ payload }) {
  return loggingAxios.post(
    `${VALAQUENTA_API_URL}/crs/internal/reservations/send-logs-to-vendors/`,
    payload
  );
}
